import * as React from "react";
const SvgHighVolume = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	...props
}, /* @__PURE__ */ React.createElement("rect", {
	x: 3.5,
	y: 9,
	width: 3,
	height: 28
}), /* @__PURE__ */ React.createElement("rect", {
	x: 9.5,
	y: 13,
	width: 3,
	height: 24
}), /* @__PURE__ */ React.createElement("rect", {
	x: 15.5,
	y: 10,
	width: 3,
	height: 27
}), /* @__PURE__ */ React.createElement("rect", {
	x: 21.5,
	y: 12,
	width: 3,
	height: 25
}), /* @__PURE__ */ React.createElement("rect", {
	x: 27.5,
	y: 3,
	width: 3,
	height: 34
}), /* @__PURE__ */ React.createElement("rect", {
	x: 33.5,
	y: 9,
	width: 3,
	height: 28
}));
export default SvgHighVolume;
